import React from "react"
import uniqBy from "lodash/uniqBy"
import sortBy from "lodash/sortBy"
import numeral from "numeral"

const currencyCollection = [
    { text: "USD", symbol: "$" },
    { text: "EUR", symbol: "€" },
    { text: "CAD", symbol: "$" },
    { text: "GBP", symbol: "£" },
    { text: "YEN", symbol: "¥" },
    { text: "INR", symbol: "₹" },
    { text: "CNY", symbol: "¥" },
    { text: "BTC", symbol: "₿" },
]

export function getCurrency(text) {
    text = text ? text : "USD"
    return getCurrencyList().find((c) => c.text === text) || ""
}

export function getCurrencySymbol(text) {
    return allC.find((c) => c.text === text)?.symbol || "$"
}

export function formatMoney(value) {
    const val = Math.abs(value)

    return numeral(value || 0)
        .format(val > 1000000 ? "0.0a" : val >= 10000 ? "0.0a" : "0,0")
        .toUpperCase()
        .replace(".0", "")
}

export function getCurrencyList() {
    let allGuys = []

    let worldC = uniqBy(allC, "text")

    worldC = sortBy(worldC, "text")

    let worldCMapp = worldC.map((c) => {
        return { text: c.text, symbol: <span>{c.symbol || "/"}</span> }
    })

    allGuys = allGuys.concat(currencyCollection).concat(worldCMapp)

    return allGuys
}

export function getAllCurrencies() {
    return allC
}

const allC = [
    { text: "USD", symbol: "$" },
    { text: "EUR", symbol: "€" },
    { text: "CAD", symbol: "$" },
    { text: "GBP", symbol: "£" },
    { text: "YEN", symbol: "¥" },
    { text: "INR", symbol: "₹" },
    { text: "CNY", symbol: "¥" },
    { text: "BTC", symbol: "₿" },
    {
        text: "AFN",
        symbol: "Af",
    },

    {
        text: "ALL",
        symbol: "L",
    },
    {
        text: "DZD",
        symbol: "د.ج",
    },
    {
        text: "USD",
        symbol: "$",
    },

    {
        text: "AOA",
        symbol: "Kz",
    },
    {
        text: "XCD",
        symbol: "$",
    },
    {
        text: "ARS",
        symbol: "$",
    },
    {
        text: "GBP",
        symbol: "£",
    },
    {
        text: "AMD",
        symbol: "Դ",
    },
    {
        text: "AWG",
        symbol: "ƒ",
    },
    {
        text: "AUD",
        symbol: "$",
    },
    {
        text: "EUR",
        symbol: "€",
    },
    {
        text: "AZN",
        symbol: "ман",
    },
    {
        text: "BSD",
        symbol: "$",
    },
    {
        text: "BHD",
        symbol: "ب.د",
    },
    {
        text: "BDT",
        symbol: "৳",
    },
    {
        text: "BBD",
        symbol: "$",
    },
    {
        text: "BYN",
        symbol: "Br",
    },
    {
        text: "BZD",
        symbol: "$",
    },
    {
        text: "XOF",
        symbol: "/",
    },
    {
        text: "BMD",
        symbol: "$",
    },
    {
        text: "INR",
        symbol: "₹",
    },
    {
        text: "BTN",
        symbol: "/",
    },
    {
        text: "BOB",
        symbol: "Bs.",
    },
    {
        text: "BOV",
        symbol: "/",
    },
    {
        text: "BAM",
        symbol: "КМ",
    },
    {
        text: "BWP",
        symbol: "P",
    },
    {
        text: "NOK",
        symbol: "kr",
    },
    {
        text: "BRL",
        symbol: "R$",
    },
    {
        text: "BND",
        symbol: "$",
    },
    {
        text: "BGN",
        symbol: "лв",
    },
    {
        text: "BIF",
        symbol: "₣",
    },
    {
        text: "CVE",
        symbol: "$",
    },
    {
        text: "KHR",
        symbol: "៛",
    },
    {
        text: "XAF",
        symbol: "₣",
    },
    {
        text: "CAD",
        symbol: "$",
    },
    {
        text: "KYD",
        symbol: "$",
    },
    {
        text: "CLP",
        symbol: "$",
    },
    {
        text: "CLF",
        symbol: "/",
    },
    {
        text: "CNY",
        symbol: "¥",
    },
    {
        text: "COP",
        symbol: "$",
    },
    {
        text: "COU",
        symbol: "/",
    },
    {
        text: "KMF",
        symbol: "/",
    },
    {
        text: "HKD",
        symbol: "$",
    },
    {
        text: "CDF",
        symbol: "₣",
    },
    {
        text: "NZD",
        symbol: "$",
    },
    {
        text: "CRC",
        symbol: "₡",
    },
    {
        text: "HRK",
        symbol: "Kn",
    },
    {
        text: "CUP",
        symbol: "$",
    },
    {
        text: "CUC",
        symbol: "/",
    },
    {
        text: "ANG",
        symbol: "/",
    },
    {
        text: "CZK",
        symbol: "Kč",
    },
    {
        text: "DKK",
        symbol: "/",
    },
    {
        text: "DJF",
        symbol: "₣",
    },
    {
        text: "XCD",
        symbol: "$",
    },
    {
        text: "DOP",
        symbol: "$",
    },
    {
        text: "EGP",
        symbol: "£",
    },
    {
        text: "SVC",
        symbol: "/",
    },
    {
        text: "XAF",
        symbol: "₣",
    },
    {
        text: "ERN",
        symbol: "Nfk",
    },
    {
        text: "ETB",
        symbol: "/",
    },
    {
        text: "FKP",
        symbol: "	£",
    },
    {
        text: "FJD",
        symbol: "$",
    },
    {
        text: "XPF",
        symbol: "₣",
    },
    {
        text: "GMD",
        symbol: "D",
    },
    {
        text: "GEL",
        symbol: "ლ",
    },
    {
        text: "GHS",
        symbol: "₵",
    },
    {
        text: "GIP",
        symbol: "£",
    },
    {
        text: "GTQ",
        symbol: "Q",
    },
    {
        text: "GNF",
        symbol: "₣",
    },
    {
        text: "GYD",
        symbol: "$",
    },
    {
        text: "HTG",
        symbol: "G",
    },
    {
        text: "HNL",
        symbol: "L",
    },
    {
        text: "HUF",
        symbol: "Ft",
    },
    {
        text: "ISK",
        symbol: "Kr",
    },
    {
        text: "IDR",
        symbol: "Rp",
    },
    {
        text: "XDR",
        symbol: "/",
    },
    {
        text: "IRR",
        symbol: "﷼",
    },
    {
        text: "IQD",
        symbol: "ع.د",
    },
    {
        text: "ILS",
        symbol: "₪",
    },
    {
        text: "JMD",
        symbol: "$",
    },
    {
        text: "JPY",
        symbol: "¥",
    },
    {
        text: "JOD",
        symbol: "د.ا",
    },
    {
        text: "KZT",
        symbol: "〒",
    },
    {
        text: "KES",
        symbol: "Sh",
    },
    {
        text: "KPW",
        symbol: "₩",
    },
    {
        text: "KRW",
        symbol: "₩",
    },
    {
        text: "KWD",
        symbol: "	د.ك",
    },
    {
        text: "KGS",
        symbol: "K",
    },
    {
        text: "LAK",
        symbol: "₭",
    },
    {
        text: "LBP",
        symbol: "ل.ل",
    },
    {
        text: "LSL",
        symbol: "L",
    },
    {
        text: "ZAR",
        symbol: "R",
    },
    {
        text: "LRD",
        symbol: "$",
    },
    {
        text: "LYD",
        symbol: "ل.د",
    },
    {
        text: "CHF",
        symbol: "₣",
    },
    {
        text: "MOP",
        symbol: "P",
    },
    {
        text: "MKD",
        symbol: "ден",
    },
    {
        text: "MGA",
        symbol: "M",
    },
    {
        text: "MWK",
        symbol: "MK",
    },
    {
        text: "MYR",
        symbol: "RM",
    },
    {
        text: "MVR",
        symbol: "M",
    },
    {
        text: "MRU",
        symbol: "UM",
    },
    {
        text: "MUR",
        symbol: "₨",
    },
    {
        text: "XUA",
        symbol: "X",
    },
    {
        text: "MXN",
        symbol: "MX",
    },
    {
        text: "MXV",
        symbol: "MX",
    },
    {
        text: "MDL",
        symbol: "L",
    },
    {
        text: "MNT",
        symbol: "₮",
    },
    {
        text: "XCD",
        symbol: "$",
    },
    {
        text: "MAD",
        symbol: "د.م.",
    },
    {
        text: "MZN",
        symbol: "MTn",
    },
    {
        text: "MMK",
        symbol: "K",
    },
    {
        text: "NAD",
        symbol: "$",
    },
    {
        text: "ZAR",
        symbol: "R",
    },
    {
        text: "NPR",
        symbol: "₨",
    },
    {
        text: "NIO",
        symbol: "C$",
    },
    {
        text: "NGN",
        symbol: "₦",
    },
    {
        text: "OMR",
        symbol: "	ر.ع.",
    },
    {
        text: "PKR",
        symbol: "₨",
    },
    {
        text: "PAB",
        symbol: "B/.",
    },
    {
        text: "PGK",
        symbol: "K",
    },
    {
        text: "PYG",
        symbol: "K",
    },
    {
        text: "PEN",
        symbol: "K",
    },
    {
        text: "PHP",
        symbol: "₱",
    },
    {
        text: "NZD",
        symbol: "$",
    },
    {
        text: "PLN",
        symbol: "zł",
    },
    {
        text: "EUR",
        symbol: "€",
    },
    {
        text: "QAR",
        symbol: "ر.ق",
    },
    {
        text: "RON",
        symbol: "lei",
    },
    {
        text: "RUB",
        symbol: "₽",
    },
    {
        text: "RWF",
        symbol: "R₣",
    },
    {
        text: "SHP",
        symbol: "£",
    },
    {
        text: "WST",
        symbol: "WST",
    },
    {
        text: "STN",
        symbol: "Db",
    },
    {
        text: "SAR",
        symbol: "SR",
    },
    {
        text: "RSD",
        symbol: "din",
    },
    {
        text: "SCR",
        symbol: "₨",
    },
    {
        text: "SLL",
        symbol: "Le",
    },
    {
        text: "SGD",
        symbol: "S$",
    },
    {
        text: "XSU",
        symbol: "K",
    },
    {
        text: "SBD",
        symbol: "Si$",
    },
    {
        text: "SOS",
        symbol: "K",
    },
    {
        text: "SSP",
        symbol: "£",
    },
    {
        text: "LKR",
        symbol: "Rs",
    },
    {
        text: "SDG",
        symbol: "ج.س.",
    },
    {
        text: "SRD",
        symbol: "$",
    },
    {
        text: "SZL",
        symbol: "EL",
    },
    {
        text: "SEK",
        symbol: "kr",
    },

    {
        text: "CHW",
        symbol: "K",
    },
    {
        text: "SYP",
        symbol: "£",
    },
    {
        text: "TWD",
        symbol: "NT$",
    },
    {
        text: "TZS",
        symbol: "TSh",
    },
    {
        text: "THB",
        symbol: "฿",
    },
    {
        text: "TOP",
        symbol: "T$",
    },
    {
        text: "TTD",
        symbol: "TT$",
    },
    {
        text: "TND",
        symbol: "DT",
    },
    {
        text: "TRY",
        symbol: "₺",
    },
    {
        text: "TMT",
        symbol: "T",
    },
    {
        text: "UGX",
        symbol: "USh",
    },
    {
        text: "UAH",
        symbol: "₴",
    },
    {
        text: "AED",
        symbol: "د.إ",
    },
    {
        text: "USN",
        symbol: "U",
    },
    {
        text: "UYU",
        symbol: "$",
    },
    {
        text: "UYI",
        symbol: "U",
    },
    {
        text: "UYW",
        symbol: "U",
    },
    {
        text: "UZS",
        symbol: "U",
    },
    {
        text: "VUV",
        symbol: "Vt",
    },
    {
        text: "VES",
        symbol: "V",
    },
    {
        text: "VND",
        symbol: "₫",
    },
    {
        text: "YER",
        symbol: "﷼",
    },
    {
        text: "ZMW",
        symbol: "ZK",
    },
    {
        text: "ZWL",
        symbol: "$",
    },
]
